import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoKkj: CultureInfo = {
  name: 'kkj',
  displayName: 'kakɔ',
  iso3LanguageCode: 'kkj',
  iso2LanguageCode: 'kkj',
  ietfLanguageTag: 'kkj',
  parent: null
};
